import {createRouter,createWebHashHistory} from "vue-router";

import Home from './components/Home.vue';
import Login from './components/Login.vue';
/*
import NewUser from './components/NewUser.vue';
*/
import RegistroAspirantes from './components/Registro/RegistroAspirante.vue';
import NotFound from './components/NotFound.vue';




const routes = [
    { path: '/', component: Login },    
    { path: '/home', component: Home },
    { path: '/registro', component: RegistroAspirantes },    
    {
      path: "/:catchAll(.*)",
      component: NotFound,
    },
  ];

const router = createRouter({    
    history: createWebHashHistory(),
    routes,    
});

export default router;